const initHeroFormScroll = () => {
  const observer = new MutationObserver(() => {
    if (document.body.hasAttribute("data-pdm-mini-form")) {
      observer.disconnect();
    }
    const heroBanner = document.querySelector(".hero-banner");
    const heroForm = document.querySelector(".hero-banner__form");
    if (!heroBanner || !heroForm) return;

    const buttons = document.querySelectorAll(
      '.hero-banner__cta-button[href="#side-popup"]',
    );
    if (!buttons.length) return;

    const header = document.querySelector(".header");

    buttons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        const headerHeight = header ? header.getBoundingClientRect().height : 0;
        const targetTop =
          heroBanner.getBoundingClientRect().top +
          window.scrollY -
          headerHeight;

        window.scrollTo({ top: targetTop, behavior: "smooth" });

        const firstField = heroForm.querySelector("input, textarea, select");
        if (firstField) {
          firstField.focus({ preventScroll: true });
        }
      });
    });
  });
  observer.observe(document.body, {
    attributes: true,
    childList: false,
    subtree: false,
    attributeFilter: ["data-pdm-mini-form"],
  });
};

export { initHeroFormScroll };
